export default __webpack_public_path__ + "images/b8943616a85d4e851c1335b7b487a4bc-top40_music.jpg";